/* SPW: MR.POINT のポイント利用パネルをカート内に組み込む (2026-09-18)
   - 既定は右下の浮遊パネル（チャット・LINEバナーと衝突）
   - カートページ／カートドロワーの小計の直上へ移設
   - それ以外の場所では非表示
   - アプリ側の初期化が終わってから移動する（初期化前に動かすと mr-point.js が落ちるため） */
(function () {
  var ROOT = 'mr-point';
  var STYLE_ID = 'spw-mrp-style';
  var started = false;

  function injectStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var s = document.createElement('style');
    s.id = STYLE_ID;
    s.textContent = [
      'mr-point .mrpoint-embed{display:none}',
      '.spw-mrp{margin:16px 0;width:100%}',
      '.spw-mrp mr-point{display:block;width:100%}',
      '.spw-mrp .mrpoint-embed{display:block;position:static;inset:auto;width:100%;max-width:none;margin:0;z-index:auto;box-shadow:none}',
      '.spw-mrp .mrpoint-embed{background:#0a0a0a;color:#fff;border:1px solid #262626}',
      '.spw-mrp .mrpoint-embed__header{cursor:pointer;background:#0a0a0a;color:#fff}',
      '.spw-mrp .mrpoint-embed__content label,.spw-mrp .mrpoint-embed__content span{color:#fff}',
      '.spw-mrp .mrpoint-embed__desc,.spw-mrp .mrpoint-embed__input-suffix{color:#b5b5b5}',
      '.spw-mrp .mrpoint-embed input{background:#fff;color:#0a0a0a;border:1px solid #d5d5d5}',
      '.spw-mrp .mrpoint-embed__error{color:#ff6b6b}'
    ].join('\n');
    document.head.appendChild(s);
  }

  // 会員ランクの表示を rank-bronze → BRONZE に整える
  function prettify(root) {
    var el = root.querySelector('.js-rank-value');
    if (!el) return;
    var t = (el.textContent || '').trim();
    if (/^rank-/i.test(t)) el.textContent = t.replace(/^rank-/i, '').toUpperCase();
  }

  // カート内では最初から開いた状態にする
  function autoOpen(root) {
    if (root.getAttribute('data-spw-opened')) return;
    var content = root.querySelector('.mrpoint-embed__content');
    var header = root.querySelector('.js-header');
    if (!content || !header) return;
    if (getComputedStyle(content).display === 'none') {
      root.setAttribute('data-spw-opened', '1');
      header.click();
    }
  }

  function findSlot() {
    var drawer = document.querySelector('.drawer--cart, #drawer-cart');
    if (drawer && drawer.classList.contains('is-visible')) {
      var ds = drawer.querySelector('.drawer__footer__subtotal');
      if (ds) return ds;
    }
    return document.querySelector('.page__footer__subtotal') ||
           document.querySelector('.drawer__footer__subtotal') ||
           document.querySelector('.cart__footer__checkout') || null;
  }

  function mount() {
    try {
      var root = document.querySelector(ROOT);
      if (!root || !root.querySelector('.mrpoint-embed')) return false;
      var slot = findSlot();
      if (!slot) return false;
      var host = slot.previousElementSibling;
      if (!host || !host.classList || !host.classList.contains('spw-mrp')) {
        host = document.createElement('div');
        host.className = 'spw-mrp';
        slot.parentNode.insertBefore(host, slot);
      }
      if (root.parentNode !== host) host.appendChild(root);
      prettify(root);
      autoOpen(root);
      return true;
    } catch (e) { return false; }
  }

  function watch() {
    var tries = 0;
    var t = setInterval(function () {
      tries++;
      mount();
      if (tries > 30) clearInterval(t);
    }, 700);
    document.addEventListener('click', function () { setTimeout(mount, 500); }, true);
  }

  function boot() {
    if (started) return;
    started = true;
    injectStyle();
    // アプリの初期化（イベント登録）を待ってから移動する
    setTimeout(function () { mount(); watch(); }, 1200);
  }

  if (document.readyState === 'complete') { boot(); }
  else { window.addEventListener('load', boot); }
})();
